import { getPreference } from '@openclassrooms/utils/config';

export const isDebug = () => getPreference('debug');

export const log =
  (namespace = 'ℹ️') =>
  (...args) => {
    args.unshift('background: #f56900; color: white');
    args.unshift(`%c ${namespace} `);

    if (isDebug()) {
      // eslint-disable-next-line prefer-spread
      window.console.log.apply(window.console, args);
    }
  };

export default {
  isDebug,
  log,
};
